import axios from 'axios'
import common from './common';
import { Toast } from 'vant'
import router from '../router';
import urls from './url'

const baseURL = common.baseUrl
// const baseURL = process.env.NODE_ENV === 'development' ? 'https://www.knowledgesource.cn' : 'https://www.knowledgesource.cn'
// const baseURL = 'http://zkcx.cxstar.cn/'

const service = axios.create({
  baseURL,
  timeout: 3000000
})
service.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem('token')) {
      // config.headers["If-Modified-Since"] = "0"
      // config.headers["Cache-Control"] = "no-cache"
      config.headers.common['Authorization'] = localStorage.getItem('token')
    }
    // if (!config.headers['No-Loading']) {
    //    toast = Toast.loading({
    //     duration: 0,
    //     forbidClick: true,
    //     loadingType: 'spinner',
    //     message: '加载中'
    //   })
    // } 
    
    
    return config
    
  },
  (error) => {
    Toast('网络有问题，稍等一会')
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (res) => {
    if (res.status === 200 && res.data.cxajaxrc !== 0) {
      
    const message = res.data.cxajaxerrmsg
    if(message === '用户未登录'){
      router.replace('login')
    }
    if (message.includes('非IP范围内') || message.includes('找不到ip')) return false

    Toast(message)
  }
  return res.data
  },
  (error) => {
    Toast('服务器异常，请重试')
    return Promise.reject(error)
  }
)


export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js